(function () {
    'use strict';

    angular
        .module('app')
        .factory('SMSTemplate', SMSTemplateFactory);

    SMSTemplateFactory.$inject = ['$q', '$window', 'SMSTemplatesService', 'DialogService'];

    function SMSTemplateFactory($q, $window, SMSTemplatesService, DialogService) {

        /**
         * Get an existing sms template.
         *
         * @param {number} smsTemplateId
         * @returns {Promise} A promise that resolves a {SMSTemplate} object for the specified smsTemplateId.
         */
        function get(smsTemplateId) {
            var smsTemplatePromise = SMSTemplatesService.get(smsTemplateId)
                .then(function (data) {
                    var smsTemplate = new SMSTemplate(data);
                    smsTemplate.dirty = false;

                    return smsTemplate;
                });

            return smsTemplatePromise;
        }

        /**
         * Create an sms template using an existing sms template.
         *
         * @param {number} smsTemplateId
         * @returns {Promise} A promise that resolves a {SMSTemplate} object copied from the specifie smsTemplateId.
         */
        function getCopy(smsTemplateId) {
            var smsTemplatePromise = SMSTemplatesService.get(smsTemplateId)
                .then(function (data) {
                    var smsTemplate = new SMSTemplate(data);

                    delete smsTemplate.data.Id;
                    delete smsTemplate.data.UpdatedDate;
                    delete smsTemplate.data.UpdatedBy;
                    delete smsTemplate.data.CreatedDate;
                    delete smsTemplate.data.CreatedBy;
                    delete smsTemplate.data.Name;

                    return $q.when(smsTemplate);
                });

            return smsTemplatePromise;
        }

        /**
         * Create a sms template with the supplied data.
         *
         * @returns {Promise} A promise that resolves a {SMSTemplate} object.
         */
        function createWithData(smsTemplateData) {
            var smsTemplate = new SMSTemplate(smsTemplateData);
            smsTemplate.dirty = false;

            return $q.when(smsTemplate);
        }

        /**
         * Get a new sms template.
         *
         * @returns {Promise} A promise that resolves a new {SMSTemplate} object.
         */
        function getNew(smsTemplateId) {
            var smsTemplate = new SMSTemplate();
            console.log(smsTemplateId);
            if (!_.isNil(smsTemplateId) && !isNaN(smsTemplateId)) {
                smsTemplate.data.EntityTemplateId = smsTemplateId;
            }

            smsTemplate.dirty = false;

            return $q.when(smsTemplate);
        }

        /**
         * Gets a list of sms templates.
         *
         * @param {int} pageSize - The page sizing for the sms template list if using paging. Optional.
         * @param {int} currentPage - The current page for the sms template list if using paging. Optional.
         * @param {string} genericSearch - 'Generic' filter for the sms template. This matches against the name or description.
         * @param {int} entityTemplateId - The parent entity template. Optional.
         *
         * @returns {Promise} A promise that resolves an array of {SMSTemplate} objects for the specified parameters.
         */
        function getSMSTemplates(pageSize, currentPage, genericSearch, entityTemplateId) {
            return SMSTemplatesService.query({ pageSize: pageSize, currentPage: currentPage, genericSearch: genericSearch, entityTemplateId: entityTemplateId })
                .then(function (data) {
                    var smsTemplates = [];

                    angular.forEach(data.Items, function (smsTemplateData) {
                        smsTemplates.push(new SMSTemplate(smsTemplateData));
                    });

                    data.Items = smsTemplates;

                    return data;
                });
        }

        /**
         * @constructor
         * 
         * @param {object} data - SMS template data used to create the SMS Template object.
         *                  This is optional, if no data is supplied, a 'new' sms template object will be created.
         *
         * @property {Object} data - SMS template data, refer C# class 'SMSTemplateConfiguration'.
         */
        function SMSTemplate(data) {
            var vm = this;

            if (!_.isNil(data)) {
                vm.data = data;
            } else {
                vm.data = {
                    Name: '',
                    Description: '',
                    Default: false,
                    Message: null,
                    To: [],
                    Active: true
                };
            }

            Object.defineProperty(vm, 'dirty', { get: getDirty, set: setDirty });
            vm.dirty = false;

            vm.delete = deleteSMSTemplate;

            // For dirty checking
            var originalData = {};

            /**
             * @returns {bool} true if the model has changed since it was last specified as not dirty.
             */
            function getDirty() {
                return !angular.equals(originalData, vm.data);
            }

            /**
             * @param {bool} Specify whether the model is dirty.
             */
            function setDirty(newDirty) {
                if (newDirty) {
                    originalData = {};
                } else {
                    originalData = angular.copy(vm.data);
                }
            }

            /**
             * Shows a 'confirm deletion dialog' and then deletes the sms template if 'Ok' is pressed.
             *
             * @returns {promise} There are three distinct states for the promise:
             *                  Fulfilled - The sms template was successfully deleted
             *                  Rejected with null value - The user 'cancelled' the confirm dialog, no attempt was made to delete the sms template
             *                  Rejected with value - An attempt was made to delete the sms template however it was not successful
             */
            function deleteSMSTemplate() {
                if (!_.isNil(vm.data.Id) && vm.data.Id !== '') {
                    return DialogService
                        .confirm('Delete the SMS Template?', 'Delete SMS Template confirm')
                        .then(function () {
                            return SMSTemplatesService.remove(vm.data.Id);
                        }, function () {
                            return $q.reject(null);
                        });
                } else {
                    return $q.reject('SMS Template does not have an Id value.');
                }
            }
        }

        SMSTemplate.prototype = {};
        SMSTemplate.prototype.constructor = SMSTemplate;

        SMSTemplate.get = get;
        SMSTemplate.getCopy = getCopy;
        SMSTemplate.getNew = getNew;
        SMSTemplate.createWithData = createWithData;
        SMSTemplate.getSMSTemplates = getSMSTemplates;

        return SMSTemplate;
    }
})();